// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const Airdrop = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 18}
    height={size ?? 18}
    fill="none"
    viewBox="0 0 18 18"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      d="M9 2c-5.879 0-7 4.7-7 8.208L8 14m-6-3.792h14M10 14l6-3.792C16 6.7 14.879 2 9 2m0 0c-2.1 0-2.5 4.7-2.5 8.208M9 2c2.1 0 2.5 4.7 2.5 8.208M8 14h2m-2 0v2h2v-2"
    />
  </svg>
);
const ForwardRef = forwardRef(Airdrop);
export default ForwardRef;
